<template>
  <div class="contest_list_item">
    <contest-banner
    @click.native="show_vote_card()"
    :contest="contest"
    :banner_type="contest_banner_type"
    ></contest-banner>
    
    <transition 
    name="" 
    enter-active-class="animated bounceInUp faster" 
    leave-active-class="animated bounceOutDown faster"
    >

      <vote-card
      :contest="contest"
      :contestant_images="contestant_images"
      :contestants="contestants"
      :vote_visible="vote_visible_toggle"
      ></vote-card>

    </transition>
  </div>
</template>

<script>
import ContestBanner from '@/features/contests/contest_banner.vue';
import VoteCard from '@/features/vote/VoteCard.vue';

export default {
  name: 'ContestListItemBox',
  props: [
    'contest',
    'contestants',
    'vote_visible',
    'contestant_images'
  ],
  data () {
    return {
      vote_visible_toggle: this.vote_visible,
      contestant_images: this.contestant_images,
      contest_banner_type: 'contest'
    }
  },
  methods: {
    show_vote_card: function() {
      this.vote_visible_toggle = !this.vote_visible_toggle;
    }
  },
  components: {
    ContestBanner,
    VoteCard
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

$contest_banner_height: 72px;

.contest_list_item {
  position: relative;
  font-size: 1.4rem;
  border-bottom: solid 1px #aaa;

  .row {
    background: $dcom-purple;
    color: #FFF;
    padding: 1.2rem 0;
  }

  .contest_category_icon {
    display: block;
    text-align: center;
  }

  .contest_banner {
    height: $contest_banner_height;
  }
}
</style>


// WEBPACK FOOTER //
// src/features/contests/contest_list_box.vue